<template>
  <div
    id="newsM"
    class="dd-container container"
  >
    <div class="left">
      <div class="readMore">
        <nuxt-link
          class="btn-wrap"
          v-if="detail.prevId"
          :to="localePath('/news/' + detail.prevId)"
        >
          <svg
            class="icon btn"
            aria-hidden="true"
          >
            <use xlink:href="#icon-zuo"></use>
          </svg>
        </nuxt-link>
        <svg
          v-else
          class="icon btn disabled"
          aria-hidden="true"
        >
          <use xlink:href="#icon-zuo"></use>
        </svg>

        <nuxt-link
          exact=""
          :to="localePath('/news')"
        >{{$t('readMore')}}</nuxt-link>

        <nuxt-link
          v-if="detail.nextId"
          class="btn-wrap"
          :to="localePath('/news/' + detail.nextId)"
        >
          <svg
            class="icon btn"
            aria-hidden="true"
          >
            <use xlink:href="#icon-you"></use>
          </svg>

        </nuxt-link>
        <svg
          v-else
          class="icon btn disabled"
          aria-hidden="true"
        >
          <use xlink:href="#icon-you"></use>
        </svg>
      </div>

      <p class="name">{{detail.name}}</p>

      <div
        class="address-wrap"
        v-if="detail.startDate || detail.address"
      >
        <p v-if="detail.startDate">{{$t('time')}}:{{detail.startDate}}—{{detail.endDate}}</p>
        <p v-if="detail.address">{{$t('address')}}:{{detail.address}}</p>
      </div>

      <div class="intro-wrap">
        <div
          ref="intro"
          class="intro"
          :class="{'intro-expand': isShowExpandIntro && expandIntro}"
          v-html="detail.content"
        ></div>

        <van-divider
          v-if="detail.content"
          @click="handleExpandIntro"
          :hairline="false"
          :style="{ width: '100%', color: '#5e5e5e', borderColor: '#e5e5e5', cursor: 'pointer' }"
        >
          <svg
            v-if="isShowExpandIntro && expandIntro"
            class="icon btn disabled"
            aria-hidden="true"
          >
            <use xlink:href="#icon-shang"></use>
          </svg>
          <svg
            v-else-if="isShowExpandIntro && !expandIntro"
            class="icon btn disabled"
            aria-hidden="true"
          >
            <use xlink:href="#icon-xia"></use>
          </svg>
        </van-divider>
      </div>

      <div
        class="artist-list"
        v-if="detail.artists && detail.artists.length "
      >
        <div
          class="artist-item"
          v-for="(item, index) in detail.artists"
          :key="index"
          :style="{cursor: item.linkUrl ? 'pointer' : ''}"
          @click="() => handleOpenUrl(item.linkUrl)"
        >
          {{item.name}}
        </div>
      </div>
    </div>

    <div class="right">
      <Banner :list="detail.imgs" />
    </div>
  </div>
  </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Divider } from 'vant'
import Banner from '@pc/news/Banner'

export default {
  data () {
    return {
      isShowExpandIntro: true,
      expandIntro: false
    }
  },

  computed: {
    ...mapState('news', ['detail'])
  },

  components: {
    [Divider.name]: Divider,
    Banner
  },

  async fetch ({ store, app, params }) {
    await store.dispatch('news/getDetail', {
      id: params.id,
      app
    })
  },

  mounted () {
    this.$nextTick(() => {
      const introDom = this.$refs.intro
      if (introDom) {
        const introDomH = introDom.offsetHeight || 0
        console.log(introDom, introDomH)
        this.isShowExpandIntro = introDomH >= 220
      }
    })
  },

  methods: {
    handleExpandIntro () {
      this.expandIntro = !this.expandIntro
    },

    handleOpenUrl (linkUrl) {
      if (linkUrl) {
        this.$openWin(linkUrl, true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-top: 40px;
  padding-bottom: 50px;

  .left {
    width: 385px;

    .readMore {
      display: flex;
      justify-content: space-between;

      span {
        font-size: 16px;
      }

      .btn {
        cursor: pointer;

        &.disabled {
          opacity: 0.3;
          cursor: default;
        }
      }

      .btn-wrap {
        width: 20px;
        height: 20px;
      }
    }

    .name {
      margin-top: 70px;
      margin-bottom: 50px;
      color: #000000;
      font-weight: bold;
      font-size: 28px;
      line-height: 40px;

      @include clamps-text-overflow(3);
    }

    .address-wrap {
      margin-bottom: 36px;

      p {
        color: #5e5e5e;
        font-size: 14px;
        line-height: 24px;
      }
    }

    .intro-wrap {
      .intro {
        overflow: hidden;
        margin-bottom: 40px;
        max-height: 220px;

        @include clamps-text-overflow(9);

        &.intro-expand {
          overflow: auto;
          max-height: inherit;

          @include clamps-text-overflow-reset();
        }
      }
    }

    ::v-deep {
      .van-divider::before,
      .van-divider::after {
        border-width: 1px 0 0;
      }

      .icon {
        height: 12px;
      }
    }

    .artist-list {
      display: inline-flex;
      flex-direction: column;
      margin-top: 40px;
    }

    .artist-item {
      display: inline-block;
      margin-bottom: 14px;
      border-bottom: 1px solid #000;
      color: #000000;
      font-weight: bold;
      font-size: 20px;
      line-height: 30px;
    }
  }

  .right {
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    width: 785px;
  }
}
</style>

<style lang="scss">
#newsM .intro {
  font-size: 12px;
  line-height: 22px;
  // * {
  //   line-height: initial;
  // }

  btn,
  textarea,
  input,
  object,
  select {
    display: inline-block;
  }
  ol,
  ul,
  dir,
  menu,
  dd {
    margin-left: 40px;
  }
  i,
  cite,
  em,
  var,
  address {
    font-style: italic;
  }

  html,
  body,
  div,
  ol,
  p,
  ul,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  address,
  blockquote,
  form,
  dd,
  dl,
  dt,
  fieldset,
  frame,
  frameset,
  center,
  dir,
  hr,
  menu,
  pre {
    display: block;
  }

  li {
    display: list-item;
  }
  ul {
    display: block;
    padding-left: 40px;
    list-style-type: disc;

    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  ol {
    display: block;
    padding-left: 40px;
    list-style: decimal;

    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
  }
  ol ul,
  ul ol,
  ul ul,
  ol ol {
    margin-top: 0;
    margin-bottom: 0;
  }

  h1 {
    margin: 0.67em 0;
    font-size: 2em;
  }
  h2 {
    margin: 0.75em 0;
    font-size: 1.5em;
  }
  h3 {
    margin: 0.83em 0;
    font-size: 1.17em;
  }
  h4,
  p,
  blockquote,
  ul,
  fieldset,
  form,
  ol,
  dl,
  dir,
  menu {
    margin: 1em 0;
  }
  h5 {
    margin: 1.5em 0;
    font-size: 0.83em;
  }
  h6 {
    margin: 1.67em 0;
    font-size: 0.75em;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  b,
  strong {
    font-weight: bolder;
  }

  a,
  a:focus,
  a:hover {
    color: rgb(32, 36, 40);
    text-decoration: underline;
  }

  br:before {
    content: ”\A”;
  }
  :before,
  :after {
    white-space: pre-line;
  }
  :link,
  :visited {
    text-decoration: underline;
  }
  :focus {
    outline: thin dotted invert;
  }

  table {
    display: table;
    border: 1px solid #000;
    border-spacing: 2px;
    border-collapse: separate;
  }
  tr {
    display: table-row;
    border: inherit;
  }
  thead {
    display: table-header-group;
    border: inherit;
  }
  tbody {
    display: table-row-group;
  }
  tfoot {
    display: table-footer-group;
  }
  col {
    display: table-column;
  }
  colgroup {
    display: table-column-group;
  }
  td,
  th {
    display: table-cell;
    border: 1px solid #000;
    vertical-align: inherit;
  }
  caption {
    display: table-caption;
    text-align: center;
  }
  th {
    text-align: center;
    font-weight: bolder;
  }
  thead,
  tbody,
  tfoot {
    vertical-align: middle;
  }

  blockquote {
    margin-right: 40px;
    margin-left: 40px;
  }
  pre,
  tt,
  code,
  kbd,
  samp {
    font-family: monospace;
  }
  pre {
    white-space: pre;
  }
  big {
    font-size: 1.17em;
  }
  small,
  sub,
  sup {
    font-size: 0.83em;
  }
  sub {
    vertical-align: sub;
  }
  sup {
    vertical-align: super;
  }
  s,
  strike,
  del {
    text-decoration: line-through;
  }
  hr {
    border: 1px inset;
  }
  u,
  ins {
    text-decoration: underline;
  }
  center {
    text-align: center;
  }
  abbr,
  acronym {
    letter-spacing: 0.1em;
    font-variant: small-caps;
  }

  bdo[DIR='ltr'] {
    unicode-bidi: bidi-override;
    direction: ltr;
  }
  bdo[DIR='rtl'] {
    unicode-bidi: bidi-override;
    direction: rtl;
  }
  /*定义BDO元素当其属性为DIR="ltr/rtl"时的默认文本读写显示顺序*/
  *[DIR='ltr'] {
    unicode-bidi: embed;
    direction: ltr;
  }
  *[DIR='rtl'] {
    unicode-bidi: embed;
    direction: rtl;
  }
  /*定义任何元素当其属性为DIR="rtl/rtl"时的默认文本读写显示顺序*/
  @media print {
    h1 {
      page-break-before: always;
    }
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      page-break-after: avoid;
    }
    ul,
    ol,
    dl {
      page-break-before: avoid;
    }
  } /*定义标题和列表默认的打印样式*/

  img {
    width: 100%;

    object-fit: contain;
  }
}
</style>
